import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as Styled from "./node-warning.style";
import { CanvasOverlay } from "./canvas-overlay";
import { AlertIcon } from "ui/components/elements/icons/alert";
export var NodeWarning = function (_a) {
    var nodeCenterX = _a.nodeCenterX, nodeCenterY = _a.nodeCenterY;
    return (_jsx(CanvasOverlay, { x: nodeCenterX, y: nodeCenterY, children: _jsx(Styled.NodeWarning, { children: _jsx(AlertIcon, { size: 18 }) }) }));
};
